import Link from "next/link";
import React from "react";
import { IArticlesCardComponent } from "shared/models/interfaces/components/article-card.interface";
import { styled } from "@mui/material/styles";
import Image from "next/image";
import { Card, CardContent, Typography, Box, Grid } from "@mui/material";

const StyledCard = styled(Card)({
  margin: "auto",
  width: "100%",
  height: "auto",
  overflow: "hidden",
  display: "block",
  textOverflow: "ellipsis",
  padding: "0px 20px",
  backgroundColor: "transparent",
  boxShadow: "none",
  "@media screen and (max-width: 500px)": {
    height: "auto",
  },
  "@media screen and (max-width: 400px)": {
    padding: "0px 30px",
  },
});

const StyledCardContent = styled("div")(({ theme }) => ({
  padding: "0",
  "&:last-child": {
    paddingBottom: 0,
  },

  "& p": {
    color: "var(--color-brand-grey-secondary)",
    fontWeight: 400,
    fontSize: "1rem",
    textAlign: "left",
    paddingTop: "10px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical",
  },

  [theme.breakpoints.down("md")]: {
    "& *": {
      textAlign: "center !important",
    },
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: "700 !important",
  fontSize: "16px",
  minHeight: "20px",
  width: "100%",
  fontFamily: "var(--font-family)",
  color: "black !important",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 1,
  WebkitBoxOrient: "vertical",
}));

const ImageWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.down("md")]: {
    alignItems: "center",
    justifyContent: "center",
  },
}));

function ArticleCard(props: IArticlesCardComponent) {
  return (
    <Link href={props.link} passHref>
      <a target="_blank">
        <StyledCard>
          <ImageWrapper>
            <Image
              src={props.img}
              width={300}
              height={170}
              style={{
                borderRadius: "10px",
              }}
              alt="Miniatura del articulo"
            />
          </ImageWrapper>

          <StyledCardContent>
            <Title>{props.title}</Title>

            <Typography
              variant="body2"
              component="p"
              style={{
                color: "var(--color-brand-grey-main)",
                fontSize: "0.975rem",
              }}
            >
              {props.extract}
            </Typography>
          </StyledCardContent>
        </StyledCard>
      </a>
    </Link>
  );
}

export default ArticleCard;
